import { IACHTransactionLogModel } from "../ach-processing/ach-transaction-log.model";
import { ICreditCardTransactionLogModel } from "../credit-card-processing/credit-card-transaction-log.model";
import { IInvoiceGridModel } from "./invoice-grid.model";

export interface IBatchPaymentModel {
    customerName: string;
    customerId: number;
    customerTypeId: number;
    total: number;
    invoiceGridModels: IInvoiceGridModel[];
    invoiceIds: number[];
    status: string;
    isProcessing: boolean;
    showInvoices: boolean;
    canClickStatus: boolean;
    isCreditCardProcessingFee: boolean;
    CreditCardProcessingFeeTotal: number;
    transactionLog: ICreditCardTransactionLogModel;
    achTransactionLog: IACHTransactionLogModel;
}

export class BatchPaymentModel implements IBatchPaymentModel {
    constructor() {
        this.invoiceGridModels = [];
        this.invoiceIds = [];
        this.total = 0;
    }
    customerName: string;
    customerId: number
    customerTypeId: number;

    total: number;
    invoiceGridModels: IInvoiceGridModel[];
    invoiceIds: number[];
    status: string;
    isProcessing: boolean;
    showInvoices: boolean;
    canClickStatus: boolean;
    isCreditCardProcessingFee: boolean;
    CreditCardProcessingFeeTotal: number;
    transactionLog: ICreditCardTransactionLogModel;
    achTransactionLog: IACHTransactionLogModel;

}